var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.calcArr.length)?_c('div',{staticClass:"promo-box",class:[_vm.klook.platform]},[_c('NewCouponEntrance',_vm._b({attrs:{"platform":_vm.klook.platform,"language":_vm.klook.language}},'NewCouponEntrance',_vm.couponData,false))],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }